import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Select from "react-dropdown-select";
import Select1 from "react-select";
import { toast } from "react-toastify";
import {
  BusinessDetailsInterface_NEW,
  RegistrationIds,
} from "../../../../assets/interface/primeSharkWebsite_interface";
import HelperService from "../../../../Services/HelperService";
import CompoLoader from "../../../ComponentLoader/CompoLoader";
import ErrorComponent from "../../../Common/ErrorComponent";
import WebService from "../../../../Services/WebService";
import { DROPDOWNTYPES } from "../../../../assets/constants/constants";
import CurrencyInputField from "../../../Common/CurrencyInput/CurrencyInputField";
import CommonScrollbar from "../../../Common/ScrollBar/CommonScrollbar";
import {
  dropdownApiNewcall,
  getCountryListAPiCall,
  getProfileJourneyInfo,
  validateAmount,
  getConvertedRangeLimits,
} from "../../../../Services/CommonFunction";
import DatePicker from "react-datepicker";
import { FaCalendarAlt } from "react-icons/fa";
import { Label } from "../../../Common/Label/Label";
import TagsInput from "react-tagsinput";
import "react-tagsinput/react-tagsinput.css";
import RequiredLabel from "../../../Common/RequiredLabel/RequiredLabel";
import "react-datepicker/dist/react-datepicker.css";
import GoogleAddressSearch from "../../../GoogleAddressSearch/GoogleAddressSearch";
import InfoIconForKeyword from "../../../Common/info/infoIcon";
import { isWarning } from "../../Helper";
import { useDispatch } from "react-redux";


interface PropsData {
  handleNext: any;
  impIds: RegistrationIds;
  from?: string;
  fields_to_improve?: any;
}
const types = [
  DROPDOWNTYPES.CHOOSE_PROFILE,
  DROPDOWNTYPES.INTERESTED_IN,
  DROPDOWNTYPES.BUSINESS_INDUSTRY,
  // DROPDOWNTYPES.BUSINESS_LOCATION,
  DROPDOWNTYPES.BUSINESS_MODEL,
  DROPDOWNTYPES.OPERATIONAL_REGION,
  DROPDOWNTYPES.INVESTMENT_ROUND,
  DROPDOWNTYPES.CAPITAL_OFFER_TYPE,
  DROPDOWNTYPES.USE_OF_FUNDS,
  DROPDOWNTYPES.CURRENT_ANNUAL_REVENUE,
  DROPDOWNTYPES.GLOBAL_TEAM_PRESENCE,
  DROPDOWNTYPES.TRAGET_INVESTOR_PROFILE,
  DROPDOWNTYPES.ESTIMATED_FUNDING_TIMELINE,
  DROPDOWNTYPES.NO_OF_EMPLOYEES,
  DROPDOWNTYPES.FUNDING_GOAL,
];

const BusinessDetails = ({
  handleNext,
  impIds,
  from,
  fields_to_improve,
}: PropsData) => {
  const { t } = useTranslation();
  const [key1, setKey1] = useState(1);
  const controlRef = useRef<HTMLDivElement | null>(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [apiCallTriggered, setAPICallTriggered] = useState(false);

  const controlRef1 = useRef<HTMLDivElement | null>(null);
  const [menuOpen1, setMenuOpen1] = useState(false);

  const controlRef2 = useRef<HTMLDivElement | null>(null);
  const [menuOpen2, setMenuOpen2] = useState(false);

  const controlRef3 = useRef<HTMLDivElement | null>(null);
  const [menuOpen3, setMenuOpen3] = useState(false);

  const controlRef5 = useRef<HTMLDivElement | null>(null);
  const [menuOpen5, setMenuOpen5] = useState(false);

  const [businessLocationList, setBusinessLocations] = useState<any[]>([]);
  const [menuOpen4, setMenuOpen4] = useState(false);
  const [issueInMinAcceptableAmount, setIssueInMinAcceptableAmt] =
    useState(false);
  const [skipButtonClicked, setSkipButtonClicked] = useState(false);
  let dispatch = useDispatch();
  useEffect(() => {
    if (!menuOpen) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];

        if (!entry.isIntersecting) {
          setMenuOpen(false);
        }
      },
      {
        root: null, // viewport
        threshold: 0, // even 1px visibility counts
      },
    );

    if (controlRef.current) {
      observer.observe(controlRef.current);
    }

    return () => observer.disconnect();
  }, [menuOpen]);

  useEffect(() => {
    if (!menuOpen1) return;
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];

        if (!entry.isIntersecting) {
          setMenuOpen1(false);
        }
      },
      {
        root: null, // viewport
        threshold: 0, // even 1px visibility counts
      },
    );

    if (controlRef1.current) {
      observer.observe(controlRef1.current);
    }
    return () => observer.disconnect();
  }, [menuOpen1]);

  useEffect(() => {
    if (!menuOpen2) return;
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];

        if (!entry.isIntersecting) {
          setMenuOpen2(false);
        }
      },
      {
        root: null, // viewport
        threshold: 0, // even 1px visibility counts
      },
    );

    if (controlRef2.current) {
      observer.observe(controlRef2.current);
    }
    return () => observer.disconnect();
  }, [menuOpen2]);

  useEffect(() => {
    if (!menuOpen3) return;
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];

        if (!entry.isIntersecting) {
          setMenuOpen3(false);
        }
      },
      {
        root: null, // viewport
        threshold: 0, // even 1px visibility counts
      },
    );

    if (controlRef3.current) {
      observer.observe(controlRef3.current);
    }
    return () => observer.disconnect();
  }, [menuOpen3]);

  useEffect(() => {
    if (!menuOpen5) return;
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];

        if (!entry.isIntersecting) {
          setMenuOpen3(false);
        }
      },
      {
        root: null, // viewport
        threshold: 0, // even 1px visibility counts
      },
    );

    if (controlRef5.current) {
      observer.observe(controlRef5.current);
    }
    return () => observer.disconnect();
  }, [menuOpen5]);

  const CustomInput = React.forwardRef(({ value, onClick }: any, ref: any) => (
    <div className="input-group w-100" onClick={onClick} ref={ref}>
      <input
        type="text"
        className="form-control"
        value={value}
        onKeyDown={(e) => {
          if (e.key === "Backspace") {
            setBussinessDetailData((prev) => ({
              ...prev,
              founding_year: "",
            }));
          }
        }}
        onChange={(e) => {
          setBussinessDetailData((prev) => ({
            ...prev,
            founding_year: e.target.value,
          }));
        }}
        placeholder="Select date"
      />
      <span className="input-group-text bg-white">
        <FaCalendarAlt />
      </span>
    </div>
  ));

  const [businessDetailData, setBussinessDetailData] =
    useState<BusinessDetailsInterface_NEW>({
      choose_profile: "",
      choose_profile_other: "",
      interested_in: [],
      business_industry: [],
      operational_region: [],
      top_selling_product: "",
      business_location: "",
      no_of_employee: "",
      ebitda: "",
      city: "",
      country: "",
      address: "",
      business_models: [],
      website_portfolio_link: "",
      founding_year: "",
      latitude: "",
      longitude: "",
      funding_goal_currency: "USD",
      funding_goal_amount: "",
      minimum_acceptable_currency: "USD",
      minimum_acceptable_investment: "",
      capital_offer_type: "",
      investment_round: "",
      use_of_funds: "",
      expected_roi: "",
      current_annual_revenue: "",
      total_investment_raised_date: "",
      investment_valuation: "",
      founder_ceo_name: "",
      core_team_members_role: "",
      global_team_presence: "",
      founder_linkedin_profile: "",
      target_investor_profile: [],
      geographies_investments: [],
      estimated_funding_timeline: "",
      strategic_partnership: "",
      company_registration_number: "",
      top_keywords: [],
      use_of_funds_other: "",
      usd_rate: 1,
      inverse_usd_rate: 1,
    });
  useEffect(() => {
    const minimumAcceptableInvestment = Number(
      businessDetailData?.minimum_acceptable_investment,
    );
    const fundingGoalAmount = businessDetailData?.funding_goal_amount;

    if (minimumAcceptableInvestment > 0) {

      const isValid = validateAmount(
        minimumAcceptableInvestment,
        fundingGoalAmount,
        businessDetailData?.usd_rate,
      );

      if (!isValid) setIssueInMinAcceptableAmt(true);
      else setIssueInMinAcceptableAmt(false);
    } else {
      setIssueInMinAcceptableAmt(false);
    }
  }, [
    businessDetailData?.minimum_acceptable_investment,
    businessDetailData?.funding_goal_amount,
    businessDetailData?.usd_rate,
  ]);

  const excludedKeys = [
    "latitude",
    "longitude",
    "expected_roi",
    "total_investment_raised_date",
    "investment_valuation",
    "business_models",
    "founder_linkedin_profile",
    "website_portfolio_link",
    "core_team_members_role",
    "state",
    "postal_code",
    "choose_profile_other",
    "use_of_funds_other",
    "use_of_funds",
    "ebitda",
    "company_registration_number",
    "top_selling_product",
    "founding_year",
    "minimum_acceptable_investment",
    "founder_ceo_name",
    "core_team_members_role",
    "strategic_partnership",
    "estimated_funding_timeline",
    "global_team_presence",
    "business_location",
    "no_of_employee",
    "capital_offer_type",
    "use_of_funds",
    "current_annual_revenue",
  ];
  const [errorFlag, setErrorFlag] = useState(false);
  const [loader, setLoader] = useState(false);
  const [dropdownData, setDropdownData] = useState<Record<string, any[]>>({});
  const [countryOptions, setCountryOptions] = useState<{ label: string; value: string }[]>([]);
  const [blKey, setblKey] = useState(1);
  useEffect(() => {
    getCountryListAPiCall("")
      .then((data: any) => {

        if (Array.isArray(data)) {
          const formatted = data.map((item: any) => ({
            flag: item?.flag,
            label: item?.title || item?.name || "",
            value: item?.title || item?.name || "",
          }));

          setCountryOptions(formatted);
          setBusinessLocations(formatted);
        }
      })
      .catch(() => { });

    if (impIds?.uuid) {
      getBusinessDetails();
    }
    loadDropdowns();
  }, []);
  async function loadDropdowns() {
    try {
      const res = await dropdownApiNewcall("investment", types);
      const formattedData: Record<string, any[]> = {};

      types.forEach((type) => {
        const items = res[type];

        if (Array.isArray(items)) {
          if (type === "business_industry") {
            const grouped = items.reduce((acc: Record<string, any[]>, item) => {
              const groupName = item.group || "Other";
              if (!acc[groupName]) acc[groupName] = [];
              acc[groupName].push({
                label: item.title,
                value: item?.is_other === 1 ? "Other" : item.title,
              });
              return acc;
            }, {});

            formattedData[type] = Object.entries(grouped).map(
              ([group, options]) => ({
                label: group,
                options,
              }),
            );
          } else {
            formattedData[type] = items.map((item) => ({
              label: item.title,
              value: item.title,
            }));
          }
        }
      });

      setDropdownData(formattedData);
    } catch (error) { }
  }

  const getBusinessDetails = () => {
    setLoader(true);
    return WebService.getAPI({
      action: `get-business/investment/${impIds?.business_uuid}`,
      body: null,
      isShowError: false,
    })
      .then((res: any) => {
        if (res?.status) {
          let info = res?.info;
          setBussinessDetailData(
            (prevBusinessDetails: BusinessDetailsInterface_NEW) => ({
              ...prevBusinessDetails,
              choose_profile: info?.choose_profile ?? "",
              choose_profile_other: info?.choose_profile_other,
              city: info?.city ?? "",
              country: info?.country ?? "",
              address: info?.address ?? "",
              no_of_employee: info?.no_of_employee ?? "",
              company_registration_number: info?.company_registration_number,
              business_models: info?.business_models,
              website_portfolio_link: info?.website_portfolio_link,
              founding_year: info?.founding_year,
              operational_region: info?.operational_region,
              funding_goal_amount: info?.funding_goal_amount ?? "",
              use_of_funds_other: info?.use_of_funds_other,
              minimum_acceptable_investment:
                info?.minimum_acceptable_investment ?? "",
              minimum_acceptable_currency:
                info?.preferred_currency ?? "USD",
              investment_round: info?.investment_round,
              capital_offer_type: info?.capital_offer_type,
              use_of_funds: info?.use_of_funds,
              expected_roi: info?.expected_roi,
              ebitda: info?.ebitda,
              current_annual_revenue: info?.current_annual_revenue,
              total_investment_raised_date:
                info?.total_investment_raised_date ?? "",
              investment_valuation: info?.investment_valuation ?? "",
              founder_ceo_name: info?.founder_ceo_name,
              core_team_members_role: info?.core_team_members_role,
              global_team_presence: info?.global_team_presence,
              founder_linkedin_profile: info?.founder_linkedin_profile,
              target_investor_profile: info?.target_investor_profile,
              geographies_investments: info?.geographies_investments,
              top_keywords: info?.top_keywords,
              interested_in:
                info?.interested_in?.length > 0
                  ? info?.interested_in.map((item: any) => ({
                    title: item?.title,
                    other: item?.other,
                  }))
                  : [],
              business_industry:
                info?.business_industry?.length > 0
                  ? info?.business_industry.map((item: any) => ({
                    title: item?.title,
                    other: item?.other,
                  }))
                  : [],
              top_selling_product: info?.top_selling_product,
              business_location: info?.business_location ?? "",
              estimated_funding_timeline: info?.estimated_funding_timeline,
              strategic_partnership: info?.strategic_partnership ?? null,
              usd_rate: info?.users?.usd_rate ?? 1,
              inverse_usd_rate: info?.users?.inverse_usd_rate ?? 1,
            }),
          );

          setKey1((prev) => prev + 1);
        } else {
          toast.error(res.message);
        }
      })
      .catch((error: any) => {
        toast.error(error?.response?.data?.message);
        WebService.removeLoader("save_basic_details");
        return error;
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const getCountryList = () => {
    getCountryListAPiCall("")
      .then((data: any) => {
        let list: any = [];
        if (data?.length > 0) {
          list = data.map((item: any) => ({
            flag: item?.flag,
            label: item?.title || item?.name || "",
            value: item?.title || item?.name || "",
          }));
        }
        setBusinessLocations(list);
        setCountryOptions(list);
      })
      .catch(() => { })
      .finally(() => { });
  };
  const handleSaveBusinessDetails = (flag: boolean) => {
    if (
      (from !== "REVIEW" && from !== "FROM_PROFILE_ANALYSIS" && issueInMinAcceptableAmount) ||
      businessDetailData?.business_industry?.length === 0 ||
      !businessDetailData?.operational_region ||
      businessDetailData?.operational_region?.length === 0 ||
      HelperService?.checkFormEmptyFields(businessDetailData, excludedKeys) ||
      (businessDetailData?.choose_profile === "Other" &&
        !businessDetailData?.choose_profile_other) ||
      (businessDetailData?.use_of_funds === "Other" &&
        !businessDetailData?.use_of_funds_other) ||
      (businessDetailData?.founder_linkedin_profile &&
        !HelperService.checkLinkedinUrl(
          businessDetailData?.founder_linkedin_profile,
        )) ||
      businessDetailData?.business_industry?.some(
        (item) =>
          item?.title === "Other" &&
          (!item?.other || item?.other?.trim() === ""),
      ) ||
      businessDetailData?.interested_in?.some(
        (item) =>
          item?.title === "Other" &&
          (!item?.other || item?.other?.trim() === ""),
      ) ||
      (businessDetailData?.website_portfolio_link &&
        !HelperService?.checkWebUrl(businessDetailData?.website_portfolio_link))
    ) {
      setErrorFlag(true);
      return;
    } else {
      setErrorFlag(false);
    }

    handleUpdateBusinessDetailsApiCall(businessDetailData, flag);
  };

  const handleUpdateBusinessDetailsApiCall = (
    data: BusinessDetailsInterface_NEW,
    flag: boolean,
  ) => {
    if (flag) WebService.addLoader("skip_business_details");
    else WebService.addLoader("save_business_details");
    setAPICallTriggered(true);
    return WebService.putAPI({
      action: `set-business/investment/${impIds?.business_uuid}`,
      body: data,
      isShowError: false,
    })
      .then((res: any) => {
        if (res?.status) {
          toast.success(res.message);
          if (from === "REVIEW" || from === "FROM_PROFILE_ANALYSIS") {
            getProfileJourneyInfo(
              impIds?.account_type?.toLocaleLowerCase(),
              impIds?.business_uuid,
              dispatch,
            );
          }

          handleNext(res);
        } else {
          toast.error(res.message);
        }
      })
      .catch((error: any) => {
        toast.error(error?.response?.data?.message);
        return error;
      })
      .finally(() => {
        if (flag) WebService.removeLoader("skip_business_details");
        else WebService.removeLoader("save_business_details");
        setAPICallTriggered(false);
      });
  };

  const handleChange = (name: string, value: string) => {
    // let { name, value } = e.target;
    setBussinessDetailData(
      (prevBusinessDetails: BusinessDetailsInterface_NEW) => ({
        ...prevBusinessDetails,
        [name]: value,
      }),
    );
  };
  const handleFounderChange = (input: string, key: string) => {
    const words = input.trim().split(/\s+/);

    if (words.length <= 350) {
      setBussinessDetailData((prev) => ({
        ...prev,
        [key]: input,
      }));
    } else {
      toast.warn("Maximum 350 words allowed");
    }
  };

  const handleArrayValueChange = (value: any[], key: string) => {
    setBussinessDetailData((prevDetails: BusinessDetailsInterface_NEW) => ({
      ...prevDetails,
      [key]: Array.isArray(value)
        ? value.map((item) => ({
          title: item?.value,
          other: item?.other || "",
        }))
        : value,
    }));
  };

  const handleChangeCurrency = (type: string, value: string) => {
    setBussinessDetailData(
      (prevBusinessDetails: BusinessDetailsInterface_NEW) => ({
        ...prevBusinessDetails,
        [type]: value,
      }),
    );
  };

  const handleYearChange = (date: Date | null) => {
    if (date) {
      setBussinessDetailData((prev) => ({
        ...prev,
        founding_year: date.getFullYear().toString(),
      }));
    }
  };

  return (
    <>
      <div className="login-form w-100 px-0 position-relative">
        {loader ? <CompoLoader /> : null}
        <div className="custom-title my-auto font-bold mb-2">
          Business Details
        </div>
        <p className="font-14 mb-1">Please enter your business details</p>
        <Row>
          <CommonScrollbar height={"65vh"}>
            <Col lg={12}>
              <div className="mb-2">
                <RequiredLabel isRequired={true}>
                  Choose your profile
                </RequiredLabel>
                <Select
                  dropdownHeight="200px"
                  options={dropdownData[DROPDOWNTYPES.CHOOSE_PROFILE] || []}
                  onChange={(values: any) => {
                    if (values?.length > 0) {
                      handleArrayValueChange(
                        values?.[0]?.value,
                        "choose_profile",
                      );
                    }
                  }}
                  className={
                    (!businessDetailData?.choose_profile && skipButtonClicked) ||
                      isWarning(fields_to_improve, "choose_profile")
                      ? "warning-field "
                      : ""
                  }
                  labelField="label"
                  valueField="value"
                  name="choose_profile"
                  values={
                    businessDetailData?.choose_profile !== ""
                      ? [
                        {
                          value: businessDetailData?.choose_profile,
                          label: businessDetailData?.choose_profile,
                        },
                      ]
                      : []
                  }
                />
                {!skipButtonClicked && (
                  <ErrorComponent
                    title="Please select profile"
                    flag={errorFlag}
                    isArray={false}
                    data={businessDetailData?.choose_profile}
                  />
                )}
              </div>
              {businessDetailData?.choose_profile === "Other" && (
                <div className="w-100 mt-2">
                  <RequiredLabel isRequired={true}>
                    Other Profile Option{ }
                  </RequiredLabel>

                  <Form.Control
                    type="text"
                    className={
                      (!businessDetailData?.choose_profile_other &&
                        skipButtonClicked) ||
                        isWarning(fields_to_improve, "choose_profile_other")
                        ? "warning-field "
                        : ""
                    }
                    name="choose_profile_other"
                    placeholder="Enter other profile option"
                    onChange={(e) => {
                      const value = e.target.value;
                      setBussinessDetailData(
                        (prev: BusinessDetailsInterface_NEW) => ({
                          ...prev,
                          choose_profile_other: value,
                        }),
                      );
                    }}
                    value={businessDetailData?.choose_profile_other}
                  />
                  {!skipButtonClicked && (
                    <ErrorComponent
                      title="Please enter other profile option"
                      flag={errorFlag}
                      isArray={false}
                      data={businessDetailData?.choose_profile_other}
                    />
                  )}
                </div>
              )}
              <div className="mb-2 mt-1">
                <RequiredLabel isRequired={false} infoMultiple>
                  Interested In(max 3)
                </RequiredLabel>
                <div ref={controlRef}>
                  <Select1
                    classNamePrefix="react-select"
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 999999 }),
                    }}
                    className={
                      isWarning(fields_to_improve, "interested_in")
                        ? "warning-field "
                        : ""
                    }
                    menuPortalTarget={document.body}
                    menuIsOpen={menuOpen}
                    onMenuOpen={() => setMenuOpen(true)}
                    onMenuClose={() => setMenuOpen(false)}
                    closeMenuOnScroll={false}
                    isClearable={businessDetailData?.interested_in?.length > 0}
                    //
                    menuPosition="fixed"
                    options={dropdownData[DROPDOWNTYPES.INTERESTED_IN] || []}
                    isMulti
                    menuPlacement="bottom"
                    onChange={(values: any) => {
                      if (values?.length > 3) {
                        toast.warn("You can select a maximum of 3 options.");
                        return false;
                      } else handleArrayValueChange(values, "interested_in");
                    }}
                    name="interested_in"
                    value={
                      businessDetailData?.interested_in?.length > 0
                        ? businessDetailData?.interested_in.map((item: any) => ({
                          value: item?.title,
                          label: item?.title,
                        }))
                        : []
                    }
                  />
                </div>
                {/* <ErrorComponent
                title="Please select interested in"
                flag={errorFlag}
                isArray={true}
                data={businessDetailData?.interested_in}
              /> */}
              </div>
              {businessDetailData?.interested_in?.some(
                (item) => item?.title === "Other",
              ) && (
                  <div className="w-100 mt-2">
                    <RequiredLabel isRequired={true}>
                      Other Interested in Option{ }
                    </RequiredLabel>
                    <Form.Control
                      type="text"
                      className={
                        isWarning(fields_to_improve, "interested_in")
                          ? "warning-field "
                          : ""
                      }
                      placeholder="Enter other interested in option"
                      onChange={(e) => {
                        const value = e.target.value;
                        setBussinessDetailData((prev) => ({
                          ...prev,
                          interested_in: prev.interested_in?.map((item: any) =>
                            item.title === "Other"
                              ? { ...item, other: value }
                              : item,
                          ),
                        }));
                      }}
                      value={
                        businessDetailData?.interested_in?.find(
                          (item) => item.title === "Other",
                        )?.other ?? ""
                      }
                    />
                    {errorFlag &&
                      businessDetailData?.interested_in?.some(
                        (item) =>
                          item?.title === "Other" &&
                          (!item?.other || item?.other?.trim() === ""),
                      ) && (
                        <Label
                          title="Please enter interested in other option"
                          modeError={true}
                        />
                      )}
                  </div>
                )}
              <div className="mb-2 w-100">
                <RequiredLabel isRequired={true}>Business Industry</RequiredLabel>

                <div ref={controlRef1}>
                  <Select1
                    classNamePrefix="react-select"
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 999999 }),
                    }}
                    className={
                      (businessDetailData?.business_industry?.length === 0 &&
                        skipButtonClicked) ||
                        isWarning(fields_to_improve, "business_industry")
                        ? "warning-field "
                        : ""
                    }
                    menuPortalTarget={document.body}
                    menuIsOpen={menuOpen1}
                    onMenuOpen={() => setMenuOpen1(true)}
                    onMenuClose={() => setMenuOpen1(false)}
                    closeMenuOnScroll={false}
                    isClearable={true}
                    menuPosition="fixed"
                    options={dropdownData[DROPDOWNTYPES.BUSINESS_INDUSTRY] || []}
                    onChange={(selectedOption: any) => {
                      if (selectedOption) {
                        const selectedValue = selectedOption.value || selectedOption.label;
                        const existingOther =
                          businessDetailData?.business_industry?.find(
                            (item: any) => item?.title === "Other" || item?.title?.toLowerCase() === "other"
                          )?.other || "";

                        const isOtherSelected =
                          selectedValue === "Other" ||
                          selectedOption?.label === "Other" ||
                          selectedOption?.is_other === 1 ||
                          (typeof selectedValue === "string" && selectedValue.toLowerCase() === "other");

                        setBussinessDetailData((prevDetails: BusinessDetailsInterface_NEW) => ({
                          ...prevDetails,
                          business_industry: [
                            {
                              title: isOtherSelected ? "Other" : selectedValue,
                              other: isOtherSelected ? existingOther : "",
                            },
                          ],
                        }));
                      } else {
                        setBussinessDetailData((prevDetails: BusinessDetailsInterface_NEW) => ({
                          ...prevDetails,
                          business_industry: [],
                        }));
                      }
                    }}
                    name="business_industry"
                    value={
                      businessDetailData?.business_industry?.length > 0 &&
                        businessDetailData?.business_industry[0]?.title
                        ? {
                          value: businessDetailData?.business_industry[0]?.title,
                          label: businessDetailData?.business_industry[0]?.title,
                        }
                        : null
                    }
                  />
                </div>
                {!skipButtonClicked && (
                  <ErrorComponent
                    title="Please select business industry"
                    flag={errorFlag}
                    isArray={true}
                    data={businessDetailData?.business_industry}
                  />
                )}
              </div>

              {businessDetailData?.business_industry?.some(
                (item) => item?.title === "Other" || item?.title?.toLowerCase() === "other",
              ) && (
                  <div className="w-100 mt-2">
                    <RequiredLabel isRequired={true}>
                      Other Business Industry
                    </RequiredLabel>
                    <Form.Control
                      type="text"
                      className={
                        isWarning(fields_to_improve, "business_industry")
                          ? "warning-field "
                          : ""
                      }
                      placeholder="Enter other business"
                      onChange={(e) => {
                        const value = e.target.value;
                        setBussinessDetailData((prev) => {
                          const list = prev.business_industry || [];
                          const hasOther = list.some(
                            (item: any) => item?.title === "Other" || item?.title?.toLowerCase() === "other"
                          );
                          return {
                            ...prev,
                            business_industry: hasOther
                              ? list.map((item: any) =>
                                item?.title === "Other" || item?.title?.toLowerCase() === "other"
                                  ? { ...item, other: value }
                                  : item,
                              )
                              : [{ title: "Other", other: value }],
                          };
                        });
                      }}
                      value={
                        businessDetailData?.business_industry?.find(
                          (item) => item?.title === "Other" || item?.title?.toLowerCase() === "other",
                        )?.other ?? ""
                      }
                    />

                    {!skipButtonClicked &&
                      errorFlag &&
                      businessDetailData?.business_industry?.some(
                        (item) =>
                          item?.title === "Other" &&
                          (!item?.other || item?.other?.trim() === ""),
                      ) && (
                        <Label
                          title="Please enter other business industry"
                          modeError={true}
                        />
                      )}
                  </div>
                )}

              <div className="mb-2 w-100">
                <RequiredLabel isRequired={false}>
                  Business Location
                </RequiredLabel>
                <Select
                  dropdownHeight="200px"
                  options={countryOptions.length > 0 ? countryOptions : businessLocationList}
                  searchable={true}
                  clearable={businessDetailData?.business_location ? true : false}
                  key={blKey}
                  className={
                    isWarning(fields_to_improve, "business_location")
                      ? "warning-field "
                      : ""
                  }
                  labelField="label"
                  valueField="value"
                  name="business_location"
                  values={
                    businessDetailData?.business_location
                      ? [
                        {
                          value: businessDetailData?.business_location,
                          label: businessDetailData?.business_location,
                          // flag: selectedBL?.flag || ""
                        },
                      ]
                      : []
                  }
                  onChange={(values: any) => {
                    if (values?.length > 0) {
                      handleArrayValueChange(
                        values?.[0]?.value,
                        "business_location",
                      );
                    } else {
                      handleArrayValueChange([], "business_location");
                    }
                  }}
                  itemRenderer={({ item, methods }) => (
                    <div
                      className="flex items-center gap-2 p-2 cursor-pointer hover:bg-gray-100"
                      onClick={() => methods.addItem(item)}
                    >
                      {item.flag && (
                        <img
                          src={item.flag}
                          width="24"
                          height="24"
                          className="me-2"
                        />
                      )}
                      <span>{item.label}</span>
                    </div>
                  )}
                />

                {/* <ErrorComponent
                title="Please select business location"
                flag={errorFlag}
                isArray={true}
                data={businessDetailData?.business_location}
              /> */}
              </div>

              <div className="mb-2 d-flex gap-1 justify-content-between ">
                <div className="w-100">
                  <GoogleAddressSearch
                    label={<RequiredLabel isRequired={true}>Head Quarter Location</RequiredLabel>}
                    mode="address"
                    value={businessDetailData?.address}
                    className={
                      (!businessDetailData?.address && skipButtonClicked) ||
                        isWarning(fields_to_improve, "address")
                        ? "warning-field "
                        : ""
                    }
                    onSelect={(
                      address: string,
                      place: google.maps.places.PlaceResult,
                      geo: { lat: number | null; lng: number | null },
                    ) => {
                      handleChange("address", address);

                      handleChange(
                        "latitude",
                        geo?.lat ? geo?.lat?.toString() : "",
                      );
                      handleChange(
                        "longitude",
                        geo?.lng ? geo?.lng?.toString() : "",
                      );
                      let city = "";
                      let state = "";
                      let country = "";
                      let pincode = "";

                      if (place.address_components) {
                        for (let component of place.address_components) {
                          if (component.types.includes("locality")) {
                            city = component.long_name;
                          }
                          if (
                            component.types.includes(
                              "administrative_area_level_1",
                            )
                          ) {
                            state = component.long_name;
                          }
                          if (component.types.includes("country")) {
                            country = component.long_name;
                          }
                          if (component.types.includes("postal_code")) {
                            pincode = component.long_name;
                          }
                        }
                      }

                      handleChange("postal_code", pincode);
                      handleChange("city", city);
                      handleChange("state", state);
                      handleChange("country", country);
                    }}
                  />
                  {!skipButtonClicked && (
                    <ErrorComponent
                      title="Please enter location"
                      flag={errorFlag}
                      isArray={false}
                      data={businessDetailData?.address}
                    />
                  )}
                </div>
              </div>
              <div className="d-flex w-100 gap-1">
                <div className="w-50">
                  <RequiredLabel isRequired={true}>City</RequiredLabel>

                  <Form.Control
                    type="text"
                    name="city"
                    placeholder="Enter city"
                    className={
                      (!businessDetailData?.city && skipButtonClicked) ||
                        isWarning(fields_to_improve, "city")
                        ? "warning-field "
                        : ""
                    }
                    onChange={(e) =>
                      handleChange(e?.target?.name, e?.target?.value)
                    }
                    value={businessDetailData?.city}
                  />
                  {!skipButtonClicked && (
                    <ErrorComponent
                      title="Please enter city"
                      flag={errorFlag}
                      isArray={false}
                      data={businessDetailData?.city}
                    />
                  )}
                </div>

                <div className="mb-2 w-50 ">
                  <RequiredLabel isRequired={false}>
                    Company Registration Number
                  </RequiredLabel>
                  <Form.Control
                    type="text"
                    name="company_registration_number"
                    placeholder="Enter company registration number"
                    onChange={(e) =>
                      handleChange(e?.target?.name, e?.target?.value)
                    }
                    className={
                      isWarning(fields_to_improve, "company_registration_number")
                        ? "warning-field "
                        : ""
                    }
                    value={businessDetailData?.company_registration_number}
                  />
                </div>
              </div>
              <div className="mb-2 d-flex w-100 gap-1">
                <div className="w-50">
                  <RequiredLabel isRequired={true}>
                    Country of Registration
                  </RequiredLabel>

                  <Select1
                    options={countryOptions}
                    placeholder="Select country"
                    value={
                      businessDetailData?.country
                        ? { label: businessDetailData.country, value: businessDetailData.country }
                        : null
                    }
                    onChange={(selected: any) =>
                      handleChange("country", selected?.value || "")
                    }
                    className={
                      (!businessDetailData?.country && skipButtonClicked) ||
                        isWarning(fields_to_improve, "country")
                        ? "warning-field"
                        : ""
                    }
                  />
                  {!skipButtonClicked && (
                    <ErrorComponent
                      title="Please enter country"
                      flag={errorFlag}
                      isArray={false}
                      data={businessDetailData?.country}
                    />
                  )}
                </div>
                <div className="mb-2 w-50">
                  <RequiredLabel isRequired={false}>
                    Number Of Employees
                  </RequiredLabel>
                  <Select
                    className={
                      isWarning(fields_to_improve, "no_of_employee")
                        ? "warning-field "
                        : ""
                    }
                    dropdownHeight="200px"
                    clearable={businessDetailData?.no_of_employee ? true : false}
                    options={dropdownData[DROPDOWNTYPES.NO_OF_EMPLOYEES] || []}
                    onChange={(values: any) => {
                      if (values?.length > 0) {
                        handleArrayValueChange(
                          values?.[0]?.value,
                          "no_of_employee",
                        );
                      } else {
                        handleArrayValueChange([], "no_of_employee");
                      }
                    }}
                    labelField="label"
                    valueField="value"
                    name="no_of_employee"
                    values={
                      businessDetailData?.no_of_employee !== ""
                        ? [
                          {
                            value: businessDetailData?.no_of_employee,
                            label: businessDetailData?.no_of_employee,
                          },
                        ]
                        : []
                    }
                  />
                </div>
              </div>
              <div className="mb-2 d-flex w-100 gap-1">
                <div className="mb-2 w-100">
                  <RequiredLabel isRequired={false}>
                    Top Selling Products/Services
                  </RequiredLabel>
                  <Form.Control
                    type="text"
                    name="top_selling_product"
                    placeholder="Enter products"
                    onChange={(e) =>
                      handleChange(e?.target?.name, e?.target?.value)
                    }
                    value={businessDetailData?.top_selling_product}
                    className={
                      isWarning(fields_to_improve, "top_selling_product")
                        ? "warning-field "
                        : ""
                    }
                  />
                </div>
              </div>

              <div className=" d-flex gap-1 mb-2 w-100">
                <div className="mb-2 w-50">
                  <RequiredLabel isRequired={false} infoMultiple>
                    Business Model(max 3)
                  </RequiredLabel>
                  <Select1
                    classNamePrefix="react-select"
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 999999 }),
                    }}
                    isClearable={businessDetailData?.business_models?.length > 0}
                    isMulti
                    menuPortalTarget={document.body}
                    menuIsOpen={menuOpen4}
                    onMenuOpen={() => setMenuOpen4(true)}
                    onMenuClose={() => setMenuOpen4(false)}
                    closeMenuOnScroll={false}
                    className={
                      isWarning(fields_to_improve, "business_model")
                        ? "warning-field"
                        : ""
                    }
                    menuPosition="fixed"
                    options={dropdownData[DROPDOWNTYPES.BUSINESS_MODEL] || []}
                    onChange={(values: any) => {
                      if (values?.length > 3) {
                        toast.warn("You can select a maximum of 3 options.");
                        return false;
                      } else handleArrayValueChange(values || [], "business_models");
                    }}
                    // labelField="label"
                    // valueField="value"
                    name="business_models"
                    value={
                      businessDetailData?.business_models?.length > 0
                        ? businessDetailData?.business_models.map(
                          (item: any) => ({
                            value: item?.title,
                            label: item?.title,
                          }),
                        )
                        : []
                    }
                  />
                </div>
                <div className="mb-2 w-50">
                  <RequiredLabel isRequired={false}>Funding Year</RequiredLabel>
                  <br></br>
                  <DatePicker
                    className={
                      isWarning(fields_to_improve, "founding_year")
                        ? "warning-field form-control text-center w-100 "
                        : "form-control text-center w-100"
                    }
                    selected={
                      businessDetailData.founding_year
                        ? new Date(`${businessDetailData.founding_year}-01-01`)
                        : null
                    }
                    wrapperClassName="w-100"
                    onChange={handleYearChange}
                    showYearPicker
                    dateFormat="yyyy"
                    minDate={new Date("1900-01-01")}
                    maxDate={new Date()}
                    placeholderText="Select year"
                    customInput={<CustomInput />}
                  />
                </div>
              </div>

              <div className="mb-2 ">
                <RequiredLabel isRequired={false}>
                  Company Website/Portfolio Link
                </RequiredLabel>

                <Form.Control
                  type="text"
                  name="website_portfolio_link"
                  placeholder="Enter website URL(e.g.https://example.com)"
                  onChange={(e) =>
                    handleChange(e?.target?.name, e?.target?.value)
                  }
                  value={businessDetailData?.website_portfolio_link}
                  className={
                    isWarning(fields_to_improve, "website_portfolio_link")
                      ? "warning-field "
                      : ""
                  }
                />
                {/* <ErrorComponent
                title="Please enter link"
                flag={errorFlag}
                isArray={false}
                data={businessDetailData?.website_portfolio_link}
              /> */}
                {businessDetailData?.website_portfolio_link &&
                  !HelperService?.checkWebUrl(
                    businessDetailData?.website_portfolio_link,
                  ) &&
                  errorFlag && (
                    <Label
                      modeError={true}
                      title="Please enter website portfolio link"
                    />
                  )}
              </div>

              <div className="mb-2 w-100 ">
                <RequiredLabel isRequired={true} infoMultiple>
                  Operational Regions
                </RequiredLabel>
                <div ref={controlRef2}>
                  <Select1
                    classNamePrefix="react-select"
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 999999 }),
                    }}
                    className={
                      errorFlag && (!businessDetailData?.operational_region || businessDetailData?.operational_region?.length === 0)
                        ? "is-invalid error-field "
                        : ((businessDetailData?.operational_region?.length == 0 &&
                          skipButtonClicked) ||
                          isWarning(fields_to_improve, "operational_region")
                          ? "warning-field "
                          : "")
                    }
                    isClearable={businessDetailData?.operational_region?.length > 0}
                    menuPortalTarget={document.body}
                    menuIsOpen={menuOpen2}
                    onMenuOpen={() => setMenuOpen2(true)}
                    onMenuClose={() => setMenuOpen2(false)}
                    closeMenuOnScroll={false}
                    menuPosition="fixed"
                    options={dropdownData[DROPDOWNTYPES.OPERATIONAL_REGION] || []}
                    isMulti
                    menuPlacement="bottom"
                    onChange={(values: any) => {
                      if (values?.length > 3) {
                        toast.warn("You can select a maximum of 3 options.");
                        return false;
                      } else handleArrayValueChange(values || [], "operational_region");
                    }}
                    name="operational_region"
                    value={
                      businessDetailData?.operational_region?.length > 0
                        ? businessDetailData?.operational_region.map(
                          (item: any) => ({
                            value: item?.title,
                            label: item?.title,
                          }),
                        )
                        : []
                    }
                  />
                </div>
                {!skipButtonClicked && (
                  <ErrorComponent
                    title="Please select operational region"
                    flag={errorFlag}
                    isArray={true}
                    data={businessDetailData?.operational_region}
                  />
                )}
              </div>
              {from !== "REVIEW" && (
                <>
                  <div className="mb-2 w-100">
                    <RequiredLabel isRequired={true}>Funding Goal</RequiredLabel>
                    <Select
                      dropdownHeight="200px"
                      clearable={
                        businessDetailData?.funding_goal_amount ? true : false
                      }
                      className={
                        (!businessDetailData?.funding_goal_amount &&
                          skipButtonClicked) ||
                          isWarning(fields_to_improve, "funding_goal_amount")
                          ? "warning-field "
                          : ""
                      }
                      options={dropdownData[DROPDOWNTYPES.FUNDING_GOAL] || []}
                      onChange={(values: any) => {
                        if (values?.length > 0) {
                          handleArrayValueChange(
                            values?.[0]?.value,
                            "funding_goal_amount",
                          );
                        } else {
                          handleArrayValueChange([], "funding_goal_amount");
                        }
                      }}
                      labelField="label"
                      valueField="value"
                      name="funding_goal_amount"
                      values={
                        businessDetailData?.funding_goal_amount !== ""
                          ? [
                            {
                              value: businessDetailData?.funding_goal_amount,
                              label: businessDetailData?.funding_goal_amount,
                            },
                          ]
                          : []
                      }
                    />
                    {!skipButtonClicked && (
                      <ErrorComponent
                        title="Please select funding goal amount"
                        flag={errorFlag}
                        isArray={false}
                        data={businessDetailData?.funding_goal_amount}
                      />
                    )}
                  </div>
                  <div className="mb-2 w-100">
                    <RequiredLabel isRequired={false}>
                      Minimum Acceptable Investment
                      {businessDetailData?.funding_goal_amount && (
                        <span style={{ fontWeight: 'normal', fontSize: '0.9em', color: '#666' }}>
                          {` (Range: ${getConvertedRangeLimits(
                            businessDetailData?.funding_goal_amount,
                            businessDetailData?.inverse_usd_rate,
                            businessDetailData?.minimum_acceptable_currency
                          )})`}
                        </span>
                      )}
                    </RequiredLabel>

                    <CurrencyInputField
                      className={
                        isWarning(fields_to_improve, "minimum_acceptable_investment")
                          ? "warning-field "
                          : ""
                      }
                      placeHolder="Enter minimum acceptable investment"
                      id="minimum_acceptable_investment"
                      prefix="$"
                      suffix=""
                      value={businessDetailData?.minimum_acceptable_investment}
                      setValue={(value: string) => {
                        handleChangeCurrency("minimum_acceptable_investment", value);
                      }}
                    />
                    {from !== "REVIEW" &&
                      from !== "FROM_PROFILE_ANALYSIS" &&
                      businessDetailData?.minimum_acceptable_investment &&
                      issueInMinAcceptableAmount && (
                        <Label
                          title={`Minimum acceptable investment must fall within the selected funding goal range (${getConvertedRangeLimits(
                            businessDetailData?.funding_goal_amount,
                            businessDetailData?.usd_rate,
                            businessDetailData?.minimum_acceptable_currency
                          )})`}
                          modeError={true}
                        />
                      )}
                  </div>
                  <div className="mb-2 w-100">
                    <RequiredLabel isRequired={true}>Investment Round</RequiredLabel>

                    <Select
                      className={
                        (!businessDetailData?.investment_round &&
                          skipButtonClicked) ||
                          isWarning(fields_to_improve, "investment_round")
                          ? "warning-field "
                          : ""
                      }
                      dropdownHeight="200px"
                      options={dropdownData[DROPDOWNTYPES.INVESTMENT_ROUND] || []}
                      onChange={(values: any) => {
                        if (values?.length > 0) {
                          handleArrayValueChange(
                            values?.[0]?.value,
                            "investment_round",
                          );
                        }
                      }}
                      labelField="label"
                      valueField="value"
                      name="investment_round"
                      values={
                        businessDetailData?.investment_round
                          ? [
                            {
                              value: businessDetailData?.investment_round,
                              label: businessDetailData?.investment_round,
                            },
                          ]
                          : []
                      }
                    />
                    {!skipButtonClicked && (
                      <ErrorComponent
                        title="Please select investment round"
                        flag={errorFlag}
                        isArray={false}
                        data={businessDetailData?.investment_round}
                      />
                    )}
                  </div>
                  <div className="mb-2 w-100">
                    <RequiredLabel isRequired={false}>
                      Capital Offer Type
                    </RequiredLabel>

                    <Select
                      clearable={
                        businessDetailData?.capital_offer_type ? true : false
                      }
                      className={
                        isWarning(fields_to_improve, "capital_offer_type")
                          ? "warning-field "
                          : ""
                      }
                      dropdownHeight="200px"
                      options={dropdownData[DROPDOWNTYPES.CAPITAL_OFFER_TYPE] || []}
                      onChange={(values: any) => {
                        if (values?.length > 0) {
                          handleArrayValueChange(
                            values?.[0]?.value,
                            "capital_offer_type",
                          );
                        } else {
                          handleArrayValueChange([], "capital_offer_type");
                        }
                      }}
                      labelField="label"
                      valueField="value"
                      name="capital_offer_type"
                      values={
                        businessDetailData?.capital_offer_type
                          ? [
                            {
                              value: businessDetailData?.capital_offer_type,
                              label: businessDetailData?.capital_offer_type,
                            },
                          ]
                          : []
                      }
                    />
                  </div>
                  <div className="mb-2 w-100">
                    <RequiredLabel isRequired={false}>Use Of Fund</RequiredLabel>

                    <Select
                      className={
                        isWarning(fields_to_improve, "use_of_funds")
                          ? "warning-field "
                          : ""
                      }
                      dropdownHeight="200px"
                      clearable={businessDetailData?.use_of_funds ? true : false}
                      options={dropdownData[DROPDOWNTYPES.USE_OF_FUNDS] || []}
                      onChange={(values: any) => {
                        if (values?.length > 0) {
                          handleArrayValueChange(values?.[0]?.value, "use_of_funds");
                        } else {
                          handleArrayValueChange([], "use_of_funds");
                        }
                      }}
                      labelField="label"
                      valueField="value"
                      name="use_of_funds"
                      values={
                        businessDetailData?.use_of_funds
                          ? [
                            {
                              value: businessDetailData?.use_of_funds,
                              label: businessDetailData?.use_of_funds,
                            },
                          ]
                          : []
                      }
                    />
                  </div>
                  {businessDetailData?.use_of_funds === "Other" && (
                    <div className="mb-2 w-100">
                      <RequiredLabel isRequired={true}>
                        Other Use Of Fund
                      </RequiredLabel>
                      <Form.Control
                        type="text"
                        placeholder="Other Use Of Fund"
                        className={
                          isWarning(fields_to_improve, "use_of_funds_other")
                            ? "warning-field "
                            : ""
                        }
                        name="use_of_funds_other"
                        value={businessDetailData?.use_of_funds_other}
                        onChange={(e) => handleChange(e.target.name, e.target.value)}
                      />
                      {errorFlag &&
                        businessDetailData?.use_of_funds === "Other" &&
                        !businessDetailData?.use_of_funds_other && (
                          <Label
                            title="Please enter other use of funds"
                            modeError={true}
                          />
                        )}
                    </div>
                  )}
                  <div className="mb-2 w-100">
                    <RequiredLabel isRequired={false}>
                      Expected ROI or Exit Strategy (if available)
                    </RequiredLabel>
                    <Form.Control
                      type="text"
                      placeholder="Enter expected ROI"
                      name="expected_roi"
                      className={
                        isWarning(fields_to_improve, "expected_roi")
                          ? "warning-field "
                          : ""
                      }
                      value={businessDetailData?.expected_roi}
                      onChange={(e) => handleChange(e.target.name, e.target.value)}
                    />
                  </div>

                  <div className="mb-2 w-100">
                    <RequiredLabel isRequired={false}>
                      EBITDA/Operating Profit Margin(%)
                    </RequiredLabel>
                    <CurrencyInputField
                      placeHolder="Enter EBITDA margin (e.g.12.5)"
                      id="ebitda"
                      prefix=""
                      suffix="%"
                      maxLength={3}
                      className={
                        isWarning(fields_to_improve, "ebitda") ? "warning-field " : ""
                      }
                      value={businessDetailData?.ebitda}
                      setValue={(value: string) => {
                        if (value.length > 3) {
                          return;
                        }
                        handleChangeCurrency("ebitda", value);
                      }}
                    />
                  </div>
                  <div className="mb-2 w-100">
                    <RequiredLabel isRequired={false}>
                      Current Annual Revenue
                    </RequiredLabel>
                    <CurrencyInputField
                      placeHolder="Please select current annual revenue"
                      id="current_annual_revenue"
                      prefix=""
                      suffix=""
                      className={
                        isWarning(fields_to_improve, "current_annual_revenue")
                          ? "warning-field "
                          : ""
                      }
                      value={businessDetailData?.current_annual_revenue}
                      setValue={(value: string) => {
                        handleChangeCurrency("current_annual_revenue", value);
                      }}
                    />
                  </div>
                  <div className="mb-2 w-100">
                    <RequiredLabel isRequired={false}>
                      Total Investment Raised to Date (if any)
                    </RequiredLabel>

                    <br></br>
                    <div className="w-100">
                      <CurrencyInputField
                        placeHolder="Enter total investment raised to date"
                        id="total_investment_raised_date"
                        prefix=""
                        suffix=""
                        className={
                          isWarning(fields_to_improve, "total_investment_raised_date")
                            ? "warning-field "
                            : ""
                        }
                        value={businessDetailData?.total_investment_raised_date}
                        setValue={(value: string) => {
                          handleChangeCurrency("total_investment_raised_date", value);
                        }}
                      />
                    </div>
                  </div>
                  <div className="mb-2 w-100">
                    <RequiredLabel isRequired={false}>
                      Current Company Valuation
                    </RequiredLabel>

                    <CurrencyInputField
                      className={
                        isWarning(fields_to_improve, "investment_valuation")
                          ? "warning-field "
                          : ""
                      }
                      placeHolder="Enter investment valuation"
                      id="investment_valuation"
                      prefix=""
                      suffix=""
                      value={businessDetailData?.investment_valuation}
                      setValue={(value: string) => {
                        handleChangeCurrency("investment_valuation", value);
                      }}
                    />
                  </div>
                </>
              )}

              <div className="mb-2">
                <div className="d-flex justify-content-between">
                  <RequiredLabel isRequired={false}>
                    Founder/CEO Name(Little introduction within 350 words)
                  </RequiredLabel>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginBottom: "2px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        // borderRadius: "10px",
                        // backgroundColor: "#ccc",
                        // width: "40x",
                        // height: "32px",
                        // color: "#fff",
                        // fontWeight: "bold",
                        // minWidth: "40px",
                      }}
                    >
                      <p className="font-10 font-bold" style={{ margin: 0 }}>
                        {businessDetailData?.founder_ceo_name?.length || 0}/350
                      </p>
                    </div>
                  </div>
                </div>
                <Form.Control
                  as="textarea"
                  placeholder="Enter Founder/CEO Name(Introduction within 350 word)"
                  style={{ height: "80px" }}
                  name="founder_ceo_name"
                  maxLength={350}
                  className={
                    isWarning(fields_to_improve, "founder_ceo_name")
                      ? "warning-field "
                      : ""
                  }
                  value={businessDetailData?.founder_ceo_name}
                  onChange={(e) =>
                    handleFounderChange(e.target.value, "founder_ceo_name")
                  }
                />
                {/* {errorFlag && !businessDetailData?.founder_ceo_name && (
                <Label
                  title="Please enter vision mission(max 350 char)"
                  modeError={true}
                />
              )} */}
              </div>
              <div className="mb-2">
                <div className="d-flex justify-content-between">
                  <RequiredLabel isRequired={false}>
                    Core Team Members & Roles(within 350 characters)
                  </RequiredLabel>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginBottom: "2px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <p className="font-10 font-bold" style={{ margin: 0 }}>
                        {businessDetailData?.core_team_members_role?.length || 0}
                        /350
                      </p>
                    </div>
                  </div>
                </div>

                <Form.Control
                  as="textarea"
                  className={
                    isWarning(fields_to_improve, "core_team_members_role")
                      ? "warning-field "
                      : ""
                  }
                  placeholder="Enter core team members & roles(within 350 characters)"
                  style={{ height: "80px" }}
                  name="core_team_members_role"
                  value={businessDetailData?.core_team_members_role}
                  onChange={(e) =>
                    handleFounderChange(e.target.value, "core_team_members_role")
                  }
                  maxLength={350}
                />
                {/* {errorFlag &&
                !businessDetailData?.core_team_members_role &&
                businessDetailData?.choose_profile !== "Individual" && (
                  <Label
                    title="Please enter core team members & role"
                    modeError={true}
                  />
                )} */}
              </div>
              <div className="mb-2 w-100">
                <RequiredLabel isRequired={false}>
                  Global Team Presence
                </RequiredLabel>
                <Select
                  clearable={
                    businessDetailData?.global_team_presence ? true : false
                  }
                  className={
                    isWarning(fields_to_improve, "global_team_presence")
                      ? "warning-field "
                      : ""
                  }
                  dropdownHeight="200px"
                  options={dropdownData[DROPDOWNTYPES.GLOBAL_TEAM_PRESENCE] || []}
                  onChange={(values: any) => {
                    if (values?.length > 0) {
                      handleArrayValueChange(
                        values?.[0]?.value,
                        "global_team_presence",
                      );
                    }
                  }}
                  labelField="label"
                  valueField="value"
                  name="global_team_presence"
                  values={
                    businessDetailData?.global_team_presence
                      ? [
                        {
                          value: businessDetailData?.global_team_presence,
                          label: businessDetailData?.global_team_presence,
                        },
                      ]
                      : []
                  }
                />
                {/* {errorFlag &&
                businessDetailData?.global_team_presence?.length === 0 && (
                  <Label
                    title="Please select current annual revenue"
                    modeError={true}
                  />
                )} */}
              </div>
              <div className="mb-2 ">
                <RequiredLabel isRequired={false}>
                  Founder's LinkedIn Profiles (if available)
                </RequiredLabel>
                <Form.Control
                  type="text"
                  className={
                    isWarning(fields_to_improve, "founder_linkedin_profile")
                      ? "warning-field "
                      : ""
                  }
                  name="founder_linkedin_profile"
                  placeholder="Enter founder linkedin profile"
                  onChange={(e) =>
                    handleChange(e?.target?.name, e?.target?.value)
                  }
                  value={businessDetailData?.founder_linkedin_profile}
                />
                {businessDetailData?.founder_linkedin_profile &&
                  !HelperService?.checkLinkedinUrl(
                    businessDetailData?.founder_linkedin_profile,
                  ) &&
                  errorFlag && (
                    <Label
                      modeError={true}
                      title="Please enter valid founder linkedin profile"
                    />
                  )}
              </div>

              {/* <div className="d-flex w-100 gap-1 mb-2"> */}
              <div className="mb-2 w-100 ">
                <RequiredLabel isRequired={false}>
                  Target Investor Profile (Angel, VC, Family Office, PE, Impact
                  Investor, etc.)(Max 3)
                </RequiredLabel>
                <div ref={controlRef3}>
                  <Select1
                    classNamePrefix="react-select"
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 999999 }),
                    }}
                    className={
                      isWarning(fields_to_improve, "target_investor")
                        ? "warning-field "
                        : ""
                    }
                    isClearable={
                      businessDetailData?.target_investor_profile?.length > 0
                    }
                    menuPortalTarget={document.body}
                    menuIsOpen={menuOpen3}
                    onMenuOpen={() => setMenuOpen3(true)}
                    onMenuClose={() => setMenuOpen3(false)}
                    closeMenuOnScroll={false}
                    menuPosition="fixed"
                    options={
                      dropdownData[DROPDOWNTYPES.TRAGET_INVESTOR_PROFILE] || []
                    }
                    isMulti
                    menuPlacement="bottom"
                    onChange={(values: any) => {
                      if (values?.length > 3) {
                        toast.warn("You can select a maximum of 3 options.");
                        return false;
                      } else if (values?.length === 0) {
                        handleArrayValueChange([], "target_investor_profile");
                      } else
                        handleArrayValueChange(values, "target_investor_profile");
                    }}
                    name="traget_investor_profile"
                    value={
                      businessDetailData?.target_investor_profile?.length > 0
                        ? businessDetailData?.target_investor_profile.map(
                          (item: any) => ({
                            value: item?.title,
                            label: item?.title,
                          }),
                        )
                        : []
                    }
                  />
                </div>
                {/* <ErrorComponent
                title="Please select target investor profile"
                flag={errorFlag}
                isArray={true}
                data={businessDetailData?.target_investor_profile}
              /> */}
              </div>
              <div className="mb-2 w-100 ">
                <RequiredLabel isRequired={false} infoMultiple>
                  Geographies You’re Seeking Investment From
                </RequiredLabel>
                <div ref={controlRef5}>
                  <Select1
                    classNamePrefix="react-select"
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 999999 }),
                    }}
                    className={
                      isWarning(
                        fields_to_improve,
                        "geographies_seeking_investment_in",
                      )
                        ? "warning-field "
                        : ""
                    }
                    menuPortalTarget={document.body}
                    menuIsOpen={menuOpen5}
                    isClearable={
                      businessDetailData?.geographies_investments?.length > 0
                    }
                    onMenuOpen={() => setMenuOpen5(true)}
                    onMenuClose={() => setMenuOpen5(false)}
                    closeMenuOnScroll={false}
                    menuPosition="fixed"
                    options={dropdownData[DROPDOWNTYPES.OPERATIONAL_REGION] || []}
                    isMulti
                    menuPlacement="bottom"
                    onChange={(values: any) => {
                      if (values?.length > 3) {
                        toast.warn("You can select a maximum of 3 options.");
                        return false;
                      } else if (values?.length === 0) {
                        handleArrayValueChange([], "geographies_investments");
                      } else
                        handleArrayValueChange(values, "geographies_investments");
                    }}
                    name="geographies_investments"
                    value={
                      businessDetailData?.geographies_investments?.length > 0
                        ? businessDetailData?.geographies_investments?.map(
                          (item: any) => ({
                            value: item?.title,
                            label: item?.title,
                          }),
                        )
                        : []
                    }
                  />
                </div>
                {/* <ErrorComponent
                title="Please select geography region"
                flag={errorFlag}
                isArray={true}
                data={businessDetailData?.geographies_investments}
              /> */}
              </div>

              <div className="mb-2 w-100">
                <RequiredLabel isRequired={false}>
                  Top Keywords for Matchmaking(Max 5)
                </RequiredLabel>
                <InfoIconForKeyword />

                <TagsInput
                  inputProps={{
                    placeholder: "Please hit ENTER to save keyword",
                    className: isWarning(fields_to_improve, "top_keywords")
                      ? "warning-field form-control react-tagsinput-input "
                      : "form-control react-tagsinput-input ",
                  }}
                  value={
                    businessDetailData?.top_keywords?.length > 0
                      ? businessDetailData?.top_keywords?.map(
                        (ele: any) => ele?.title,
                      )
                      : []
                  }
                  preventSubmit
                  addOnPaste
                  onlyUnique
                  onChange={(tags: string[]) => {
                    if (tags?.length > 5) {
                      toast.warn("Max 5 keywords allowed!");
                      return;
                    }
                    setBussinessDetailData(
                      (prev: BusinessDetailsInterface_NEW) => ({
                        ...prev,
                        top_keywords: tags.map((tag) => ({ title: tag })),
                      }),
                    );
                  }}
                />
                {/* <ErrorComponent
                title="Please enter at least one keyword"
                flag={errorFlag}
                isArray={true}
                data={businessDetailData?.top_keywords}
              /> */}
              </div>
              <div className="mb-2">
                <RequiredLabel isRequired={false}>
                  Estimated Funding Timeline
                </RequiredLabel>

                <Select
                  className={
                    isWarning(fields_to_improve, "estimated_funding_timeline")
                      ? "warning-field "
                      : ""
                  }
                  dropdownHeight="200px"
                  clearable={
                    businessDetailData?.estimated_funding_timeline ? true : false
                  }
                  options={
                    dropdownData[DROPDOWNTYPES.ESTIMATED_FUNDING_TIMELINE] || []
                  }
                  onChange={(values: any) => {
                    if (values?.length > 0) {
                      handleArrayValueChange(
                        values?.[0]?.value,
                        "estimated_funding_timeline",
                      );
                    } else {
                      handleArrayValueChange([], "estimated_funding_timeline");
                    }
                  }}
                  labelField="label"
                  valueField="value"
                  name="estimated_funding_timeline"
                  values={
                    businessDetailData?.estimated_funding_timeline
                      ? [
                        {
                          value: businessDetailData?.estimated_funding_timeline,
                          label: businessDetailData?.estimated_funding_timeline,
                        },
                      ]
                      : []
                  }
                />
                {/* <ErrorComponent
                  title="Please select estimated funding timeline"
                  flag={errorFlag}
                  isArray={false}
                  data={businessDetailData?.estimated_funding_timeline}
                /> */}
              </div>

              <div className="mb-2">
                <RequiredLabel isRequired={false}>
                  Are you open to Strategic Partnerships or Board Involvement?
                </RequiredLabel>
                <div className="d-flex gap-3 mt-1">
                  <div
                    className={`form-check warning-radio-wrapper ${isWarning(fields_to_improve, "strategic_partnership")
                      ? "active-warning"
                      : ""
                      }`}
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      name="strategic_partnership"
                      id="yes"
                      value="1"
                      checked={
                        businessDetailData?.strategic_partnership === "1" ||
                        businessDetailData?.strategic_partnership === 1
                      }
                      onChange={(e) =>
                        setBussinessDetailData(
                          (pre: BusinessDetailsInterface_NEW) => ({
                            ...pre,
                            strategic_partnership: e.target.value,
                          }),
                        )
                      }
                    />
                    <label className="form-check-label" htmlFor="yes">
                      Yes
                    </label>
                  </div>

                  <div
                    className={`form-check warning-radio-wrapper ${isWarning(fields_to_improve, "strategic_partnership")
                      ? "active-warning"
                      : ""
                      }`}
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      name="agreement"
                      id="no"
                      value="0"
                      checked={
                        businessDetailData?.strategic_partnership === "0" ||
                        businessDetailData?.strategic_partnership === 0
                      }
                      onChange={(e) =>
                        setBussinessDetailData(
                          (pre: BusinessDetailsInterface_NEW) => ({
                            ...pre,
                            strategic_partnership: e.target.value,
                          }),
                        )
                      }
                    />
                    <label className="form-check-label" htmlFor="no">
                      No
                    </label>
                  </div>
                </div>
                {/* <ErrorComponent
                  title="Please select "
                  flag={errorFlag}
                  isArray={false}
                  data={businessDetailData?.strategic_partnership}
                /> */}
              </div>

              <div className="mb-2 d-flex gap-2">
                <Button
                  className={
                    from === "REVIEW" || from === "FROM_PROFILE_ANALYSIS"
                      ? "btn btn-primary w-100"
                      : "btn btn-primary w-50"
                  }
                  type="button"
                  disabled={apiCallTriggered}
                  id="save_business_details"
                  onClick={() => {
                    setSkipButtonClicked(false);
                    handleSaveBusinessDetails(false);
                  }}
                >
                  {" "}
                  {from && from === "REVIEW"
                    ? t("Register.save")
                    : t("Register.continue")}
                </Button>
                {from !== "REVIEW" && from !== "FROM_PROFILE_ANALYSIS" && (
                  <Button
                    className="btn btn-secondary w-50"
                    type="button"
                    disabled={apiCallTriggered}
                    id="skip_business_details"
                    onClick={() => {
                      setSkipButtonClicked(true);
                      handleSaveBusinessDetails(true);
                    }}
                  >
                    Skip
                  </Button>
                )}
              </div>
            </Col>{" "}
          </CommonScrollbar>
        </Row>
      </div>
    </>
  );
};
export default BusinessDetails;
